import { render, staticRenderFns } from "./Personnel.vue?vue&type=template&id=5f196dcb&scoped=true&"
import script from "./Personnel.vue?vue&type=script&lang=js&"
export * from "./Personnel.vue?vue&type=script&lang=js&"
import style0 from "./Personnel.vue?vue&type=style&index=0&id=5f196dcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f196dcb",
  null
  
)

export default component.exports